import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

export const ClientClient = new RestClient(atmoClient, "client");
